var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2642 49.4083L27.2017 26.9999M38.4517 7.51428C28.747 1.91129 16.6033 4.3595 9.75516 12.7865C9.08675 13.609 8.75254 14.0202 8.65532 14.6095C8.57797 15.0783 8.69256 15.6996 8.93207 16.1099C9.23311 16.6257 9.76667 16.9338 10.8338 17.5499L43.5695 36.4499C44.6367 37.0659 45.1702 37.374 45.7674 37.3768C46.2426 37.3791 46.8379 37.1677 47.2052 36.8663C47.6669 36.4874 47.856 35.9924 48.2341 35.0023C52.1079 24.8581 48.1563 13.1173 38.4517 7.51428ZM38.4517 7.51428C34.147 5.029 25.6206 11.7383 19.4074 22.4999M38.4517 7.51428C42.7563 9.99956 41.2091 20.7383 34.9959 31.4999M49.7017 49.4998H4.70166",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidays);
export default __webpack_public_path__ + "static/media/Holidays.fc7d340e57305451c238ffa9bee538aa.svg";
export { ForwardRef as ReactComponent };